import React from "react";
import { ProductItemComponentProps } from "../../constants/interface.ts";
import IconCardComponent from "../IconCardComponent/IconCardComponent.tsx";
import { useTranslation } from "react-i18next";

const ProductServicesComponent = (props: ProductItemComponentProps) => {
    const { title = '', paragraph = '', list = [] } = props;
    const {t} = useTranslation();

    return (
        <div className="flex flex-col gap-8 lg:gap-16">
            <div className="flex flex-col gap-5">
                <p className="text-3xl font-semibold text-black-1A1 lg:text-4xl">{t(title)}</p>
                <>
                {
                    (paragraph) &&
                    <p className="text-base font-normal text-gray-535 lg:text-xl lg:max-w-[40rem]">{t(paragraph)}</p>
                }
                </>
            </div>
            <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                {
                    list?.map((item, index: number) => (
                        <React.Fragment key={index}>
                            <IconCardComponent
                                classes={'text-white bg-blue-1F3'}
                                img={item.img || ''}
                                imgContainerClass={'bg-light-gray-E9E text-gray-414'}
                                title={item.title || ''}
                                titleClass={'text-light-gray-E9E'}
                                paragraph={item.paragraph || ''}
                                paragraphClass={'text-gray-E9E'}
                                index={index}
                            />
                        </React.Fragment>
                    ))
                }
            </div>
        </div>
    );
};

export default ProductServicesComponent;